let React =            require("react");
let MasterPage =       require("./../../pages/generic/MasterPage.jsx");
let DataListPage =     require("./../../pages/generic/DataListPage.jsx");
let EmptyLibraryCard = require("./../empty/EmptyLibraryCard.jsx");
let LibraryCard =      require("./../cards/LibraryCard.jsx");

class ExploreLibraries extends React.Component {

    constructor() {
        super()

        //this.state = { search: "", doingSearch: false, pageIndex: 1, error: {}};
    }

    componentDidMount() {
        document.title = `Explore/libraries | library.io`;
        googleGA("send", "event", `explore/libraries`, "pageview");
    }

    render() {
        //this config is necessary because search pages reuse the explorer view, by default the config is for explore pages, that config could be changed from the search page
        let {hasSearching = false} = this.props;

        return  <DataListPage
                    {...this.props}
                    page="explore"
                    endpoint="/explore/libraries"
                    displayName={`Libraries`}
                    showNumElements={true}
                    urlName="libraries"
                    cssCardTag="library"
                    defaultLayout="grid"
                    hasSearching={hasSearching}
                    loginRequired={false}
                    canSwitchLayout
                    isPublicFacing={true}
                    resetViewAfterNewUpload
                    uploadContentIsAboveTitle
                    EmptyCard={EmptyLibraryCard}
                    CardType={LibraryCard}
                    hasSelectSort={true}
                    hasGridLayoutSwitch={false}
                    showLoadingPlaceholder={false}
                />
    }
}

module.exports = ExploreLibraries;
